import { Card, CardContent, IconButton, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import React, { useContext } from 'react'
// import BackingTrackGeneratorSectionsContext from './sectionsStore/BackingTrackGeneratorSectionsContext'
import BackingTrackGeneratorEditorContext from './editorStore/BackingTrackGeneratorEditorContext'

const BackingTrackSectionHeader = (props: {
	section: any,
	sectionIndex: number
}) => {
	const {
		section,
		sectionIndex
	} = props

	// const [sections, dispatchSections] = useContext(BackingTrackGeneratorSectionsContext)

	const [editor, dispatchEditor] = useContext(BackingTrackGeneratorEditorContext)

	const handleAddBar = () => {
		// const newSections = [...sections]
		// newSections[sectionIndex].bars.push(['_', '_', '_', '_'])// TODO update bars to object[] to handle custom pattern
		// setSections(newSections)
	}
	
	return (
		<div style={{ display: 'flex' }}>
			<Card style={{ width: 48, opacity: 0.6, marginBottom: 12 }}>
				<CardContent style={{ padding: '8px 16px' }}>
					<Typography variant='h5'>{section.name}</Typography>
				</CardContent>
			</Card>
			{/* <IconButton disabled={editor.state.isPlaying} onClick={handleAddBar} aria-label="add bar">
				<AddIcon />
			</IconButton> */}
		</div>
	)
}

export default BackingTrackSectionHeader
